<template>
  <Button @click="tapEvent">与小程序交互</Button>
</template>

<script>
export default {
  methods: {
    tapEvent() {
      uni.webView.navigateBack()
      uni.webView.postMessage({
        data: {
          action: '交互信息', //发送的消息
        },
      })
    },
  },
}
</script>

<style></style>
